import { ReactNode, forwardRef } from 'react';
import Typography, { TypographyProps as MuiTypographyProps } from '@mui/material/Typography';

interface TypographyProps extends Omit<MuiTypographyProps, 'children'> {
  children: ReactNode;
}

export const TypographyComponent = forwardRef<HTMLElement, TypographyProps>(
  ({ children, variant, ...otherProps }, ref) => {
    return (
      <Typography ref={ref} variant={variant} {...otherProps}>
        {children}
      </Typography>
    );
  }
);

TypographyComponent.displayName = 'TypographyComponent';
